import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";

const Campaigns = () => {
    const [campaigns, setCampaigns] = useState([]);
    const { jwtToken } = useOutletContext();
    const [totalPages, setTotalPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const navigate = useNavigate();

    useEffect(() => {
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + jwtToken);

        const requestOptions = {
            method: "GET",
            headers: headers,
        };
        fetch(
            `${process.env.REACT_APP_BACKEND}/api/campaigns?page=${currentPage}`,
            requestOptions
        )
            .then((response) => response.json())
            .then((data) => {
                setCampaigns(data.campaigns);
                setTotalPages(data.totalPages);
                if (data.currentPage !== currentPage) {
                    setCurrentPage(data.currentPage);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, [currentPage]);

    return (
        <div>
            <h2>Кампании покупателей</h2>
            <table className="table table-stripped table-hover">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Регион/Город</th>
                        <th>Активность</th>
                        <th>Время</th>
                        <th>Дни</th>
                        <th>Цена</th>
                        <th>Дневной лимит</th>
                        <th>Баланс</th>
                    </tr>
                </thead>
                <tbody>
                    {campaigns.map((c) => (
                        <tr key={c.id}>
                            <td>{c.id}</td>
                            <td>
                                <Link to={`/campaigns/${c.id}`}>
                                    {c.townOrRegionName}
                                </Link>
                            </td>
                            <td>{c.activeStatus}</td>
                            <td>
                                {c.timeFrom} - {c.timeTo}
                            </td>
                            <td>{c.days}</td>
                            <td>{c.price / 100}</td>
                            <td>{c.leadsDayLimit}</td>
                            <td>{c.balance / 100}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <nav aria-label="Page navigation example">
                <ul className="pagination">
                    <li className="page-item">
                        <a
                            className="page-link"
                            href="#"
                            aria-label="Previous"
                            onClick={() =>
                                setCurrentPage((prev) => Math.max(prev - 1, 1))
                            }
                        >
                            <span aria-hidden="true">&laquo;</span>
                        </a>
                    </li>
                    {Array.from(Array(Math.min(totalPages, 10)).keys()).map(
                        (p) => (
                            <li
                                key={p}
                                className={`page-item ${
                                    p + 1 === currentPage ? "active" : ""
                                }`}
                            >
                                <a
                                    className="page-link"
                                    href="#"
                                    onClick={() => setCurrentPage(p + 1)}
                                >
                                    {p + 1}
                                </a>
                            </li>
                        )
                    )}
                    <li className="page-item">
                        <a
                            className="page-link"
                            href="#"
                            aria-label="Next"
                            onClick={() =>
                                setCurrentPage((prev) =>
                                    Math.min(prev + 1, totalPages)
                                )
                            }
                        >
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default Campaigns;
